import { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Backdrop, CircularProgress } from "@material-ui/core";
import DataTable from "../components/DataTable";
import Announcement from "../components/Announcement";
import alarm from "../assets/alarm.svg";
import death from "../assets/death.svg";
import caution from "../assets/caution.svg";
import { useEffect } from "react";
import { AppContext } from "../AppContext";
import PieChart from "../components/PieChart";
import { generatePieData } from "../components/Utils";

const useStyles = makeStyles({
  date: {
    fontSize: "2rem",
    fontWeight: "200",
    marginTop: "20px",
  },
  high: {
    zIndex: 2000,
  },
});

const Hoy = () => {
  const classes = useStyles();
  const {
    today,
    setToday,
    newCasesPieData,
    setNewCasesPieData,
    newDeathsPieData,
    setNewDeathsPieData,
  } = useContext(AppContext);

  useEffect(() => {
    const fetchToday = async () => {
      if (today) return;

      const res = await fetch(
        "https://api-sinaloa-covid-app.netlify.app/today.json"
      );
      let data = await res.json();
      setToday(data);
      setNewDeathsPieData(generatePieData(data, "newDeaths"));
      setNewCasesPieData(generatePieData(data, "newCases"));
      console.log(data);
    };
    fetchToday();
  }, [today, setToday, setNewCasesPieData, setNewDeathsPieData]);

  return (
    <>
      {today ? (
        <>
          <p className={classes.date}>{today.dateStr}</p>
          <Announcement src={death}>
            <strong>{today.globalNewDeaths}</strong> Muertes
          </Announcement>
          <Announcement src={alarm}>
            <strong>{today.globalNewCases}</strong> Nuevos Casos
          </Announcement>
          <Announcement src={caution}>
            Sinaloa Está en
            <strong
              style={{
                color: today.trafficLight.color,
                textShadow: "0px 0px 5px gray",
              }}
            >
              {` ${today.trafficLight.name}`}
            </strong>
          </Announcement>
          <PieChart
            title="Nuevos Casos"
            pieData={newCasesPieData}
            global={today.globalNewCases}
          />
          <DataTable
            title="Casos"
            cities={today.cities.newCases}
            global={today.globalNewCases}
          />
          <PieChart
            title="Nuevas Muertes"
            pieData={newDeathsPieData}
            global={today.globalNewDeaths}
          />
          <DataTable
            title="Muertes"
            cities={today.cities.newDeaths}
            global={today.globalNewDeaths}
          />
        </>
      ) : (
        <Backdrop open={true} className={classes.high}>
          <CircularProgress color="primary" className={classes.high} />
        </Backdrop>
      )}
    </>
  );
};

export default Hoy;
